(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
  Apply to any text input. Replaces input with decimal (to the 10ths place) equivalent
  Strips non digits.
  
  Example of expected results where length = 3
  input => result
  0 => 0
  0.0 => 0.0
  0. => 0.
  1 => 0.1
  12 => 1.2
  123 => 12.3
  1234 => 12.3
  1.2 => 1.2
  12.3 => 12.3
  12.33.4 => 12.3
  asdf1 => 0.1
   */

  App.angularApp.directive('mfForceDecimal', [
    '$parse', function($parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          mfForceDecimal: '=?'
        },
        link: (function(_this) {
          return function($scope, elem, attrs, ngModel) {
            var base, base1;
            if ($scope.mfForceDecimal == null) {
              $scope.mfForceDecimal = {};
            }
            if ((base = $scope.mfForceDecimal).digits == null) {
              base.digits = 3;
            }
            if ((base1 = $scope.mfForceDecimal).places == null) {
              base1.places = 1;
            }
            return ngModel.$parsers.unshift(function(viewValue) {
              var place, previous;
              if (viewValue !== '' && (viewValue !== '0' && viewValue !== '0.' && viewValue !== '0.0')) {
                previous = $scope.previous;
                if (viewValue !== previous) {
                  viewValue = String(viewValue).replace(/[\.\D]/g, '');
                  viewValue = viewValue.slice(0, $scope.mfForceDecimal.digits);
                  place = Math.pow(10, $scope.mfForceDecimal.places);
                  $scope.previous = parseFloat(viewValue / place).toFixed($scope.mfForceDecimal.places);
                  ngModel.$setViewValue($scope.previous);
                  ngModel.$render();
                  return $scope.previous;
                }
              }
              return viewValue;
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
